module.exports = __webpack_public_path__ + "static/media/bgcredit-score.42310148.svg";